<div id = "top-section"></div>
<app-header class="small-header"></app-header>

<div class="mobile">
  <!-- <div class="section-title-sec flex mar-top-25" >
    <div class="flex" *ngIf = "!selectedCategory || !selectedCategory.attributes || !selectedCategory.attributes.sub_categories || selectedCategory.attributes.sub_categories.length == 0">
      <div class="section-img"><img [src] = "selectedCategory?.attributes?.logo_url" class="img-fluid"></div>
      <div class="section-title pad-top-2 f600 c2C2A2A fnt-15" [ngStyle]="{'color': GlobalConstants.data.colors.main_text_color}">{{selectedCategory?.attributes?.name}}</div>
    </div>

    <div class="sub-cat flex" *ngIf = "selectedCategory && selectedCategory.attributes && selectedCategory.attributes.sub_categories && selectedCategory.attributes.sub_categories.length > 0">
      <div class="searchdrop relative special-drop" dropdown>
          <div class="w100 h100 flex align-center pointer fnt-16 f500" dropdownToggle>
            <div class="flex">
              <div class="section-img"><img [src] = "selectedCategory?.attributes?.logo_url" class="img-fluid"></div>
              <div class="section-title pad-top-2 f600 c2C2A2A fnt-15" [ngStyle]="{'color': GlobalConstants.data.colors.main_text_color}">{{selectedCategory?.attributes?.name}}</div>
            </div>
            <svg class="mar-left-5 mar-top-3" width="14" height="7" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L5 5L9 1" stroke="#333" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <div class="dropdown-menu dropdown-menu-shadow w100 pad-7 project-drop mar-top-8" *dropdownMenu>

            <div *ngFor="let sub_category of selectedCategory.attributes.sub_categories" class="">
              <a  class="option-box block pointer capitalize" >{{sub_category.name}}</a>
            </div>

          </div>
          <span class="icon-down-open-mini"></span>
      </div>
    </div>
  </div> -->
  <section class="breadcrumbs-parent" *ngIf = "selectedCategory">
    <div class="main-category flex align-center pad-right-5">
      <a class="back-icon" (click) = "backToListing()">
      <svg xmlns="http://www.w3.org/2000/svg" fill = "#032082" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 386.242 386.242" style="enable-background:new 0 0 386.242 386.242;" xml:space="preserve">
        <g>
        	<path id="Arrow_Back" d="M374.212,182.3H39.432l100.152-99.767c4.704-4.704,4.704-12.319,0-17.011   c-4.704-4.704-12.319-4.704-17.011,0L3.474,184.61c-4.632,4.632-4.632,12.379,0,17.011l119.1,119.1   c4.704,4.704,12.319,4.704,17.011,0c4.704-4.704,4.704-12.319,0-17.011L39.432,206.36h334.779c6.641,0,12.03-5.39,12.03-12.03   S380.852,182.3,374.212,182.3z"/>
        </g>
        </svg>
      </a>
      <a class="fnt-13 flex align-center justify-center f600 pad-top-1" [routerLink] = "'/offer/offer-list/'+selectedCategory?.attributes?.code">{{selectedCategory?.attributes?.name}}</a>
    </div>
    <div class="breadcrumbs-sec flex pad-top-5 pad-bot-10 text-center custom-scroller">
      <a class="sub-cat fnt-11 flex align-center justify-center" [class.active] = "!selectedSubCategory" [routerLink] = "'/offer/offer-list/'+selectedCategory?.attributes?.code">ALL</a>
      <a [class.active] = "selectedSubCategory && selectedSubCategory.id == sub_category.id" [routerLink] = "'/offer/offer-list/'+selectedCategory?.attributes?.code+'/'+sub_category.code" class="sub-cat fnt-11 flex align-center justify-center" *ngFor="let sub_category of selectedCategory?.attributes?.sub_categories">
        {{sub_category?.name}}
      </a>
    </div>
  </section>
  <div *ngIf = "is_loading" class="flex align-center justify-center h100 loader-parent ">
    <div class="page-loader"></div>
  </div>

  <section class="special-offers container mar-top-25" *ngIf="!is_loading && merchants">
    <div class="flex wrap">
      <div class="flex item mar-bot-20"  *ngFor="let merchant of merchants">
        <app-offers-card class="block w100" [merchant]="merchant" [authenticated_user]="authenticated_user" [isMobile]="true"
          (claimOffer)="redeemOffer(merchant)">
        </app-offers-card>
      </div>
    </div>
  </section>
  <div class="pagination-block" *ngIf="totalPages > 1">
    <div class="flex justify-center align-center">
      <div class="fir-lst fnt-12 disabled flex align-center pointer" (click)="pageClicked(1)">FIRST
      </div>

      <div class="page-number" *ngIf="pageNumStart > 0">....</div>
      <div class="page-number pointer"
        *ngFor="let item of totalPageNumbers | slice:pageNumStart:pageNumEnd; let i = index;"
        [style.background-color]="item == currentPage - 1 ? GlobalConstants.data.colors.mainBtn_color : ''"
        [ngClass]="{'active' : item == currentPage - 1}" (click)="pageClicked(item+1)">{{item+1}}
      </div>
      <div class="page-number" *ngIf="totalPages > pageNumEnd">....</div>

      <div class="fir-lst fnt-12 flex align-center pointer" (click)="pageClicked(totalPages)">LAST
      </div>
    </div>
  </div>
</div>
